(function () {
    'use strict';

    angular.module("imApp").factory("customsTarifService", ['$ihttp', function ($ihttp) {
        let service = {
            getTarif: function (parms) {
                return $ihttp.post({
                    method: 1727,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1728,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
